import './assets/styles/main.scss';

import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import VueScrollTo from 'vue-scrollto';
import smoothscroll from 'smoothscroll-polyfill';

import { setupCalendar } from 'v-calendar';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import App from '@/App.vue';
import Go from '@/components/utils/Go.vue';
import Image from '@/components/utils/Image.vue';

import store, { key } from './store';
import focusDirective from './directives/focus';
import { maska } from 'maska'

import router, { setupAuth, setupRoleBasedAccess } from './router';
import { setupI18n } from './i18n';
import CustomButton from './components/utils/CustomButton.vue';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  PieController,
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, PieController);

import 'v-calendar/dist/style.css';
import 'dropzone/dist/basic.css';

const i18n = setupI18n(router);
setupAuth(router, i18n);
setupRoleBasedAccess(router, store);

// polyfills
// --------------------------------
smoothscroll.polyfill();

// app
// --------------------------------
const app = createApp(App);

const head = createHead();
app.use(head);
app.use(store, key);
app.use(VueScrollTo);
app.use(router);
app.use(i18n);
app.use(setupCalendar, {});
app.use(VueGoogleMaps, {
  load: {
    key: window.env.VITE_GOOGLE_MAPS_API_TOKEN || import.meta.env.VITE_GOOGLE_MAPS_API_TOKEN,
    libraries: 'places'
  },
});

// Provide gmap api as it is only added as global by the plugin
// and cannot be used in setup scripts like that
app.provide('gmapApiPromiseLazy', app.$gmapApiPromiseLazy);

// i18n
// --------------------------------
//

// custom components
// --------------------------------
app.component('Go', Go);
app.component('Image', Image);
app.component('CustomButton', CustomButton);

app.directive('focus', focusDirective);
app.directive('maska', maska);

app.mount('#app');
